import { useMutation } from '@tanstack/react-query';

import { gaEvents, sendGACommonEvent } from '../helpers/gaTracker';
import { firebasePostApi } from './firebaseApi';

const baseUrl = '/user';

const SUPPORT_REQUEST_ENDPOINT = {
  supportTaskTicket: `${baseUrl}/contact-support-task`,
};

const contactCustomerSupportQueryKey = 'submit-customer-support';

export const REAMS_SUPPORT_REASON = {
  remainingDays: 'Rent Navigator trial remaining days expired.',
  activeLocations: 'Rent Navigator trial active locations limit reached.',
  createLocation: 'Rent Navigator trial create location limit reached.',
  downloadLocations:
    'Rent Navigator trial locations CSV download limit reached.',
  downloadRents: 'Rent Navigator trial rent data download limit reached.',
  downloadLocationSummary:
    'Rent Navigator trial location summary powerpoint download limit reached.',
  downloadRentComparison:
    'Rent Navigator trial rent comparison powerpoint download limit reached.',
  activateLicense:
    'Rent Navigator license activation requested for existing licensed user.',
  trialExpiredContactSales:
    'Rent Navigator trial expired - user wants to talk to sales about a license.',
};

export const RETAIL_MARKET_ANALYSIS_SUPPORT_REASON = {
  remainingDays: 'Retail Market analysis trial remaining days expired.',
  activeLocations:
    'Retail Market analysis trial active locations limit reached.',
  createLocation: 'Retail Market analysis trial create location limit reached.',
  downloadLocations:
    'Retail Market analysis trial locations CSV download limit reached.',
};

export const useContactCustomerSupport = () => {
  const contactCustomerSupport = ({ supportReason }) => {
    sendGACommonEvent(gaEvents.SUPPORT_TICKET, {
      support_reason: supportReason,
    });

    return firebasePostApi(SUPPORT_REQUEST_ENDPOINT.supportTaskTicket, {
      supportReason,
    });
  };

  const { mutateAsync, isLoading, isPending } = useMutation({
    mutationKey: [contactCustomerSupportQueryKey],
    mutationFn: contactCustomerSupport,
  });

  return {
    contactCustomerSupport: mutateAsync,
    isLoading: isLoading || isPending,
  };
};
